import storage from 'store/dist/store.modern';
import expire from 'store/plugins/expire';

storage.addPlugin(expire);

export { storage };
